import * as React from "react";
import type { SVGProps } from "react";
const SvgCloseToMetroIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M8.4 1.68c-2.144 0-3.92 1.678-3.92 3.762v1.015a.57.57 0 0 0 0 .49v7.91a.57.57 0 0 0 0 .49v4.97c0 1.683 1.157 3.105 2.73 3.588l-2.013 2.012a.57.57 0 0 0 0 .805.57.57 0 0 0 .805 0l2.643-2.642h10.71l2.642 2.642a.57.57 0 0 0 .805 0 .57.57 0 0 0 0-.805l-2.012-2.012c1.573-.483 2.73-1.905 2.73-3.588v-5.092a.6.6 0 0 0 0-.228V6.825a.6.6 0 0 0 0-.228V5.442c0-2.084-1.776-3.762-3.92-3.762zm0 1.12h11.2c1.566 0 2.8 1.194 2.8 2.642v.718h-8.277a.5.5 0 0 0-.175-.018l-.053.018H5.6v-.718C5.6 3.994 6.834 2.8 8.4 2.8m.962 1.12a.567.567 0 0 0 .158 1.12h8.96a.56.56 0 0 0 .492-.278c.1-.175.1-.39 0-.564a.56.56 0 0 0-.492-.278H9.362M5.6 7.28h7.84v7.28H5.6zm8.96 0h7.84v7.28h-7.84zm-8.96 8.4h16.8v4.637c0 1.416-1.18 2.59-2.695 2.643h-.017a.6.6 0 0 0-.193 0H8.4c-1.566 0-2.8-1.194-2.8-2.643zm3.36 1.12a2.247 2.247 0 0 0-2.24 2.24 2.247 2.247 0 0 0 2.24 2.24 2.247 2.247 0 0 0 2.24-2.24 2.247 2.247 0 0 0-2.24-2.24m10.08 0a2.247 2.247 0 0 0-2.24 2.24 2.247 2.247 0 0 0 2.24 2.24 2.247 2.247 0 0 0 2.24-2.24 2.247 2.247 0 0 0-2.24-2.24M8.96 17.92c.626 0 1.12.494 1.12 1.12s-.494 1.12-1.12 1.12-1.12-.494-1.12-1.12.494-1.12 1.12-1.12m10.08 0c.626 0 1.12.494 1.12 1.12s-.494 1.12-1.12 1.12-1.12-.494-1.12-1.12.494-1.12 1.12-1.12"
    />
  </svg>
);
export default SvgCloseToMetroIcon;
